import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { z } from "zod";
import { ZodExtended } from "@/data/zod.extended";
import { ProfileModels } from "./profile.models";
import { CommonModels } from "@/data/common/common.models";

export namespace ProfileApi {
export const getMy = () => { 
    return AppRestClient.get( 
        { resSchema: ProfileModels.FullProfileResponseDtoSchema }, 
        `/profile/me`,
        
    )
};

export const update = (data: ProfileModels.UpdateProfileDto, ) => { 
    return AppRestClient.put( 
        { resSchema: ProfileModels.FullProfileResponseDtoSchema }, 
        `/profile/me`,
        ZodExtended.parse(ProfileModels.UpdateProfileDtoSchema, data)
, 
        
    )
};

export const updateIntroduction = (data: ProfileModels.UpdateIntroductionDto, ) => { 
    return AppRestClient.put( 
        { resSchema: z.void() }, 
        `/profile/me/introduction`,
        ZodExtended.parse(ProfileModels.UpdateIntroductionDtoSchema, data)
, 
        
    )
};

export const updateVisibility = (data: ProfileModels.ProfileFieldChangeVisibilityRequest, ) => { 
    return AppRestClient.put( 
        { resSchema: ProfileModels.FullProfileResponseDtoSchema }, 
        `/profile/me/visibility`,
        ZodExtended.parse(ProfileModels.ProfileFieldChangeVisibilityRequestSchema, data)
, 
        
    )
};

export const reset = () => { 
    return AppRestClient.get( 
        { resSchema: z.void() }, 
        `/profile/me/reset`,
        
    )
};

export const requestPictureUpload = (data: ProfileModels.MediaUploadRequest, ) => { 
    return AppRestClient.post( 
        { resSchema: CommonModels.MediaUploadInstructionsSchema }, 
        `/profile/me/profile-picture/request-upload`,
        ZodExtended.parse(ProfileModels.MediaUploadRequestSchema, data)
, 
        
    )
};

export const validatePictureUpload = (data: ProfileModels.MediaAttachRequestDto, ) => { 
    return AppRestClient.put( 
        { resSchema: ProfileModels.MediaValidatedResponseSchema }, 
        `/profile/me/profile-picture`,
        ZodExtended.parse(ProfileModels.MediaAttachRequestDtoSchema, data)
, 
        
    )
};

export const requestIntroductionCoverImageUpload = (data: ProfileModels.MediaUploadRequest, ) => { 
    return AppRestClient.post( 
        { resSchema: CommonModels.MediaUploadInstructionsSchema }, 
        `/profile/me/introduction-cover-image/request-upload`,
        ZodExtended.parse(ProfileModels.MediaUploadRequestSchema, data)
, 
        
    )
};

export const validateIntroductionCoverImageUpload = (data: ProfileModels.MediaAttachRequestDto, ) => { 
    return AppRestClient.put( 
        { resSchema: ProfileModels.MediaValidatedResponseSchema }, 
        `/profile/me/introduction-cover-image`,
        ZodExtended.parse(ProfileModels.MediaAttachRequestDtoSchema, data)
, 
        
    )
};

export const deleteIntroductionCoverImage = () => { 
    return AppRestClient.delete( 
        { resSchema: z.void() }, 
        `/profile/me/introduction-cover-image`,
        
    )
};

export const getJobSkillMatrix = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileJobSkillMatrixResponseDtoSchema }, 
        `/profile/me/job-skill-matrix`,
        
    )
};

export const getBlsSkillIndustry = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileBlsSkillIndustryResponseDtoSchema }, 
        `/profile/me/bls-skill-industry`,
        
    )
};

export const generateBio = () => { 
    return AppRestClient.post( 
        { resSchema: ProfileModels.GenerateBioResponseDtoSchema }, 
        `/profile/me/generate-bio`,
        
    )
};

export const updateSkills = (data: ProfileModels.UpdateSkillsDto, ) => { 
    return AppRestClient.put( 
        { resSchema: ProfileModels.ProfileSkillsResponseDtoSchema }, 
        `/profile/me/skills`,
        ZodExtended.parse(ProfileModels.UpdateSkillsDtoSchema, data)
, 
        
    )
};

export const updatePositionInfo = (data: ProfileModels.UpdatePositionInfoDto, ) => { 
    return AppRestClient.put( 
        { resSchema: z.void() }, 
        `/profile/me/position-info`,
        ZodExtended.parse(ProfileModels.UpdatePositionInfoDtoSchema, data)
, 
        
    )
};

export const updatePersonalInfo = (data: ProfileModels.UpdatePersonalInfoDto, ) => { 
    return AppRestClient.put( 
        { resSchema: z.void() }, 
        `/profile/me/personal-info`,
        ZodExtended.parse(ProfileModels.UpdatePersonalInfoDtoSchema, data)
, 
        
    )
};

export const updateWorkExperience = (data: ProfileModels.UpdateWorkExperienceDto, ) => { 
    return AppRestClient.put( 
        { resSchema: z.void() }, 
        `/profile/me/work-experience`,
        ZodExtended.parse(ProfileModels.UpdateWorkExperienceDtoSchema, data)
, 
        
    )
};

export const updateEducations = (data: ProfileModels.UpdateEducationsDto, ) => { 
    return AppRestClient.put( 
        { resSchema: z.void() }, 
        `/profile/me/educations`,
        ZodExtended.parse(ProfileModels.UpdateEducationsDtoSchema, data)
, 
        
    )
};

export const updateVolunteerInfo = (data: ProfileModels.UpdateVolunteersDto, ) => { 
    return AppRestClient.put( 
        { resSchema: z.void() }, 
        `/profile/me/volunteer-info`,
        ZodExtended.parse(ProfileModels.UpdateVolunteersDtoSchema, data)
, 
        
    )
};

export const updateCertificationsInfo = (data: ProfileModels.UpdateCertificationsDto, ) => { 
    return AppRestClient.put( 
        { resSchema: z.void() }, 
        `/profile/me/certifications`,
        ZodExtended.parse(ProfileModels.UpdateCertificationsDtoSchema, data)
, 
        
    )
};

export const updateAchievementsInfo = (data: ProfileModels.UpdateAchievementsDto, ) => { 
    return AppRestClient.put( 
        { resSchema: z.void() }, 
        `/profile/me/achievements`,
        ZodExtended.parse(ProfileModels.UpdateAchievementsDtoSchema, data)
, 
        
    )
};

}
